import { BaseModel } from './baseModel';
import type { Sheet } from './sheet';
import { WorkbookStyle } from './workbookStyle';

export class Workbook extends BaseModel {
  public sheets: Sheet[] = [];
  public style = new WorkbookStyle();
}
